import { clearRefinements } from "instantsearch.js/es/lib/utils";
import jQuery from "jquery";

// use jQuery as $ to avoid conflicts with other libraries
window.$ = window.jQuery = jQuery;

// Get all the menu items and dropdowns
const menuItems = document.querySelectorAll(".dropdown-btn");
const dropdowns = document.querySelectorAll(".dropdown-menu");

// Add event listeners for each menu item
menuItems.forEach((menuItem, index) => {
	let isDropdownHovered = false;

	// Show the dropdown on menu item hover
	menuItem.addEventListener("mouseover", () => {
		if (!isDropdownHovered) {
			// Hide all dropdowns
			dropdowns.forEach((dropdown) => {
				dropdown.style.display = "none";
			});

			// Show the corresponding dropdown
			dropdowns[index].style.display = "block";
			menuItem.classList.add("active"); // Add 'active' class to menu item
		}
	});

	// Hide the dropdown when the mouse leaves the menu item
	menuItem.addEventListener("mouseout", () => {
		if (!isDropdownHovered) {
			dropdowns[index].style.display = "none";
			menuItem.classList.remove("active"); // Remove 'active' class from menu item
		}
	});

	// Handle dropdown hover
	dropdowns[index].addEventListener("mouseover", () => {
		isDropdownHovered = true;
		dropdowns[index].style.display = "block";
		menuItem.classList.add("active"); // Add 'active' class to menu item
	});

	dropdowns[index].addEventListener("mouseout", () => {
		isDropdownHovered = false;
		dropdowns[index].style.display = "none";
		menuItem.classList.remove("active"); // Remove 'active' class from menu item
	});
});

// ISI Click and scroll events
window.addEventListener("scroll", function () {
	var isiElements = document.getElementsByClassName("isi");
	if (isiElements.length > 0) {
		var target = isiElements[0].offsetTop - window.innerHeight + 500;

		if (window.pageYOffset >= target && window.pageYOffset !== 0) {
			var isiNoticeElement = document.getElementsByClassName("isi-notice");
			if (isiNoticeElement.length > 0) {
				isiNoticeElement[0].style.display = "none";
			}
		} else {
			var isiNoticeElement = document.getElementsByClassName("isi-notice");
			if (isiNoticeElement.length > 0) {
				isiNoticeElement[0].style.display = "block";
			}
		}
	}
});

document.querySelectorAll(".isi-link").forEach(function (link) {
	link.addEventListener("click", function (event) {
		event.preventDefault(); // Prevent the default click behavior

		var isiWrapper = document.querySelector(".isi");
		var fixedIsi = document.querySelector(".isi-notice");

		// Scroll to the top position of isiWrapper over a duration of 1000 milliseconds (1 second)
		window.scrollTo({
			top: isiWrapper.offsetTop,
			behavior: "smooth",
		});
		// Hide elements with the class "fixedIsi"
		fixedIsi.style.display = "none";
	});
});

// Generate Block Query Loop when there are no posts
// Get all elements with the class "gb-query-loop-wrapper"
var queryLoopWrappers = document.querySelectorAll(".gb-query-loop-wrapper");
// Loop through each element
queryLoopWrappers.forEach(function (wrapper) {
	// Check if the element is empty
	if (wrapper.innerHTML.trim() === "") {
		// Get the previous sibling
		var prevSibling = wrapper.previousElementSibling;
		// remove parent wrapper
		//wrapper.parentElement.remove();
		// Remove the previous sibling and wrapper
		prevSibling.remove();
		wrapper.remove();
	}
});

// if .wp-block-group has no content, remove the block
var groupBlocks = document.querySelectorAll(".wp-block-group");
groupBlocks.forEach(function (block) {
	if (block.innerHTML.trim() === "") {
		block.remove();
	}
});

// 8 x 8 Chatbot
// if (
// 	document.getElementById(
// 		"__8x8-chat-button-container-script_63547477860242c5d2df100.30337094"
// 	)
// ) {
// 	window.__8x8Chat = {
// 		uuid: "script_63547477860242c5d2df100.30337094",
// 		tenant: "Y29vcGVyc3VyZ2ljYWwwNw",
// 		channel: "(Cooper) CS Chat",
// 		domain: "https://vcc-na9.8x8.com",
// 		path: "/.",
// 		buttonContainerId:
// 			"__8x8-chat-button-container-script_63547477860242c5d2df100.30337094",
// 		align: "right",
// 	};
// 	(function () {
// 		var se = document.createElement("script");
// 		se.type = "text/javascript";
// 		se.async = true;
// 		se.src =
// 			window.__8x8Chat.domain +
// 			window.__8x8Chat.path +
// 			"/CHAT/common/js/chat.js";
// 		var os = document.getElementsByTagName("script")[0];
// 		os.parentNode.insertBefore(se, os);
// 	})();
// 	setTimeout(function () {
// 		var chatbotIcon = (document.querySelector(
// 			"img[alt='Chatbot Icon']"
// 		).style.height = "50px");
// 		var chatbotIcon = (document.querySelector(
// 			"img[alt='Chatbot Icon']"
// 		).style.width = "50px");

// 		var chatbotIcon = (document.querySelector(
// 			"img[alt='Chatbot Icon']"
// 		).style.marginRight = "20px");

// 		var chatbotIcon = (document.querySelector(
// 			"img[alt='Chatbot Icon']"
// 		).style.marginBottom = "20px");
// 	}, 1000);
// }

if (document.querySelector(".wp-block-acf-sales-team-instasearch")) {
	document.addEventListener("DOMContentLoaded", function (event) {
		const continentDropdown = document.getElementById("continent");
		const countryDropdown = document.getElementById("country");
		const USstateDropdown = document.getElementById("state");
		const CAregionDropdown = document.getElementById("region");
		const repHits = document.getElementById("rep-hits");
		const repMessage = document.getElementById(
			"local-representative-selector-message"
		);
		const clearRefinementsButton = document.getElementById("clear-refinements");

		continentDropdown.addEventListener("change", function () {
			const clearRefinementsButton = document.querySelector(
				".ais-ClearRefinements-button"
			);

			var continentDropdownValue = continentDropdown.querySelector(
				".ais-MenuSelect-select"
			).value;

			if (continentDropdownValue != "") {
				countryDropdown.classList.remove("d-none");
				repMessage.classList.remove("d-none");
				// add this text to the message in innerHTML to repMessage "Please choose a country to find a local representative."
				repMessage.innerHTML =
					"Please choose a country to find a local representative.";
			} else {
				countryDropdown.classList.add("d-none");
				USstateDropdown.classList.add("d-none");
				CAregionDropdown.classList.add("d-none");
				repHits.classList.add("d-none");
				clearRefinementsButton.click();
			}
		});

		countryDropdown.addEventListener("change", function () {
			const clearRefinementsButton = document.querySelector(
				".ais-ClearRefinements-button"
			);
			var countryDropdownValue = countryDropdown.querySelector(
				".ais-MenuSelect-select"
			).value;

			if (countryDropdownValue != "") {
				repHits.classList.remove("d-none");
				repMessage.classList.add("d-none");
			}

			if (countryDropdownValue == "United States") {
				USstateDropdown.classList.remove("d-none");
				CAregionDropdown.classList.add("d-none");
				repMessage.classList.remove("d-none");

				// clear repMessage and update with "Please choose a state to find a local representative."
				repMessage.innerHTML =
					"Please choose a state to find a local representative.";

				repHits.classList.add("d-none");
			}
			if (countryDropdownValue == "Canada") {
				CAregionDropdown.classList.remove("d-none");
				USstateDropdown.classList.add("d-none");
				repMessage.classList.remove("d-none");

				repMessage.innerHTML =
					"Please choose a region to find a local representative.";

				repHits.classList.add("d-none");
			} else if (countryDropdownValue == "") {
				USstateDropdown.classList.add("d-none");
				CAregionDropdown.classList.add("d-none");
				countryDropdown.classList.add("d-none");
				repHits.classList.add("d-none");
				clearRefinementsButton.click();
			}
		});

		USstateDropdown.addEventListener("change", function () {
			const clearRefinementsButton = document.querySelector(
				".ais-ClearRefinements-button"
			);
			var USstateDropdownValue = USstateDropdown.querySelector(
				".ais-MenuSelect-select"
			).value;

			if (USstateDropdownValue != "") {
				repHits.classList.remove("d-none");
				repMessage.classList.add("d-none");
			} else {
				repHits.classList.add("d-none");
				clearRefinementsButton.click();
			}
		});

		CAregionDropdown.addEventListener("change", function () {
			const clearRefinementsButton = document.querySelector(
				".ais-ClearRefinements-button"
			);
			var CAregionDropdownValue = CAregionDropdown.querySelector(
				".ais-MenuSelect-select"
			).value;

			if (CAregionDropdownValue != "") {
				repHits.classList.remove("d-none");
				repMessage.classList.add("d-none");
			} else {
				repHits.classList.add("d-none");
				clearRefinementsButton.click();
			}
		});

		clearRefinementsButton.addEventListener("click", function () {
			countryDropdown.classList.add("d-none");
			USstateDropdown.classList.add("d-none");
			CAregionDropdown.classList.add("d-none");
			repHits.classList.add("d-none");
			repMessage.classList.add("d-none");
		});
	});
}
